module.exports = __webpack_public_path__ + "img/logo2.205a66c8.png";